<template lang='pug'>

// content
section
  v-container#change( fluid fullheight pa-0 white )
    v-layout( row wrap )

      // toolbar
      v-flex( xs12 )
        v-toolbar.py-0( flat )
          v-toolbar-items
            v-btn.rounded-0( 
              :color='invoice ? "" : "accent"'
              depressed 
              @click='invoice = false'
              ) boleta
            v-switch.px-3( 
              hide-details 
              style='padding-top: 19px;' 
              v-model='invoice'
              )
            v-btn.rounded-0( 
              :color='invoice ? "accent" : ""'
              depressed 
              @click='invoice = true'
              ) FACTURA
            .mx-4
            v-text-field(
              background-color='grey lighten-2 rounded-0'
              height='64'
              hide-details
              flat
              :loading='busy.number'
              prefix='Folio: '
              solo
              small
              style='width: 400px;'
              v-model='number'
              @keyup.enter='handleNumberEnter'
              )
            v-btn.rounded-0( 
              color='primary' 
              depressed 
              @click='handleNumberEnter'
              ) buscar
            v-btn.rounded-0( 
              color='secondary' 
              depressed 
              @click='handleCleanClick'
              ) limpiar

      // incoming items
      v-flex( xs12 style='height: calc(50vh - 160px); overflow: auto;' )
        h4.body-2.text-uppercase.py-2.px-4.d-block.accent.white--text entra
        v-data-table( 
          :headers='headers'
          hide-actions
          :items='incomingItems'
          :loading='busy.number'
          no-data-text='Sin items.'
          )
          template( slot='items' slot-scope='props' )
            td.subheading
              counter-control(
                info-label='cant: '
                :info-value='parseFloat(props.item.quantity)'
                :max-value='parseFloat(props.item.quantity)'
                v-model='props.item.quantity_change'
                @input='handleCounter'
                )
            td.py-2 
              h3.body-2 {{ props.item.wh_product.name }}
              h3.body-1 UPC: {{ props.item.wh_product.upc_codes.join(', ') }}
              h3.body-1( style='float: right; margin-top: -21px;' ) COD: {{ props.item.wh_product.internal_code }}
            td.text-xs-center
              h3.body-2 {{ parseFloat(props.item.price) | mixFormatCurrency }}
            td.text-xs-center
              h3.body-2 
                span {{ parseFloat(props.item.discount_or_charge_value_with_iva) | mixFormatCurrency }} 
                span ({{ parseFloat(props.item.discount_or_charge_percentage) }}%)
            td.text-xs-center
              h3.body-2 {{ parseFloat(props.item.remaining_amount) | mixFormatCurrency }}
        v-divider
      
      // outgoing items
      v-flex( xs12 style='height: calc(50vh - 119px);' )
        h4.body-2.text-uppercase.py-2.px-4.d-block.primary.white--text sale
        sales-cart( @scanner:blur='handleScannerBlur()' ) 

  // summary info
  v-container( fluid px-2 py-1 style='position: fixed; bottom: 10px; height: 120px; width: calc(98.6%)' )
    v-layout( row wrap )

      // subtotals
      v-flex( xs12 sm6 )
        h1.headline.text-uppercase.grey--text.text--darken-4 Total entrante: 
          strong {{ incomingTotal | mixFormatCurrency }}
        h1.headline.text-uppercase.grey--text.text--darken-4 Total saliente&nbsp;&nbsp;: 
          strong {{ outgoingTotal | mixFormatCurrency }}
        .pr-4
          v-btn( 
            block 
            color='primary' 
            large 
            outline 
            @click='handleCleanClick'
            ) cancelar

      // total
      v-flex( xs12 sm6 text-xs-right )
        h1.display-1.text-uppercase.grey--text.text--darken-4 Total venta: 
          strong {{ outgoingTotal - incomingTotal | mixFormatCurrency }}
        v-btn( 
          block 
          color='primary' 
          :disabled='!changeAvailable'
          large 
          depressed 
          style='margin: 29px 0 0' 
            @click='handleConfirmClick'
          ) confirmar

  // error dialog
  v-dialog( persistent width='600' v-model='dialogs.change' )
    v-card( color='primary' dark )
      v-card-title.title Realizando cambio
      v-progress-linear.ma-0( color='accent' indeterminate )
      v-container( grey darken-4 fluid )
        v-layout( row wrap )
          v-flex( xs12 sm6 style='white-space: pre;' )
            h4.body-2 Entrada
            | Tipo de documento: {{ invoice ? 'FACTURA' : 'BOLETA' }}
            | Folio: {{ number || '?' }}
            | Items: {{ incomingItems.length }}
            | Subtotal: {{ incomingTotal | mixFormatCurrency }}            
          v-flex( xs12 sm6 style='white-space: pre;' )
            h4.body-2 Salida
            | Tipo de documento: VALE VENTA
            | Items: {{ outgoingItems.length }}
            | Subtotal: {{ outgoingTotal | mixFormatCurrency }}

  // error dialog
  v-dialog( width='600' v-model='dialogs.error' )
    v-card( color='error' dark )
      v-card-title.title Error
      v-card-text.subheading {{ error }}
      v-card-actions
        v-spacer
        v-btn( 
          color='error darken-2' 
          depressed 
          @click='dialogs.error = false' 
          ) cerrar

  // confirm dialog
  salesperson-modal(
    v-model='dialogs.confirm',
    :color='activeTransaction.color',
    @submit='handleSalesPersonSubmit'
    )

  // supervisor dialog
  auth-modal(
    v-model='dialogs.supervisor',
    :color='activeTransaction.color',
    @submit='handleSupervisorSubmit'
    )

  // success dialog
  v-dialog( width='600' v-model='dialogs.success' )
    v-card( color='success' dark )
      v-card-title.title Exito
      v-card-text.subheading {{ success }}
      v-card-actions
        v-spacer
        v-btn( 
          color='success darken-2' 
          depressed 
          @click='dialogs.success = false' 
          ) cerrar
          
    v-snackbar(
        :value='showSnackbar',
        :color='colors.danger',
        :timeout='0',
        auto-height
    )
        p.text-xs-center(v-html='errorMessage') 
</template>

<script>
import axios from 'axios'
import CounterControl from '@/components/CounterControl/CounterControl'
import TextFormatting from '../../mixins/TextFormatting.js'
import SalesCart from '../../components/SalePoint/SalesCart/SalesCart'
import { mapGetters, mapState, mapActions } from 'vuex'
import { splitDateTimeString } from '@/services/JSUtils'
import AuthModal from '@/components/SimpleAuth/AuthModal'
import SalespersonModal from '@/components/SimpleAuth/SalespersonModal'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import printerApi from '@/services/printerApi'
import { cloneDeep } from 'lodash'

// services
import GAuthorizationService from '@/services/API/General/GAuthorization'
import GBarAuthorizationService from '@/services/API/General/GBarAuthorization'
import SlSaleInvoiceService from '@/services/API/Sale/SlSaleInvoice'
import SlSaleTicketService from '@/services/API/Sale/SlSaleTicket'
import SlServiceOrderService from '@/services/API/Sale/SlServiceOrder'

const route = process.env.VUE_APP_API_ROUTE + '/'
export default {
    name: 'product-change',
    data () {
      return {
        //
        busy: {
          number: false,
        },
        dialogs: {
          change: false,
          confirm: false,
          error: false,
          supervisor: false,
          success: false,
        },
        error: '',
        success: '',
        number: '',
        slSaleInvoice: {
          details: [],
        },
        slSaleTicket: {
          details: [],
        },
        //
        invoice: false,
        docNumber: '',
        incomingList: [],
        changeMode: false,
        show: false,
        authStatus: false,
        showSalespersonModal: false,
        salespersonStatus: true,
        salesPersonName: '',
        salespersonCode: '',
        salespersonID: '',
        supervisorCode: '',
        supervisorID: '',
        customer_id: null,
        customer_branch_office_id: null,
        errorMessage: '',
        loadingDocument: false,
        customer_core_business_id: null,
      }
    },
    computed: {
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction',
        }),
        ...mapState('CartModule', {
            total: 'total',
            items: 'items',
        }),
        ...mapState('SessionModule', ['companyData', 'htmlPrint']),

        /**
         * 
         */
        changeAvailable() {
          return (
            this.incomingItems.length > 0 &&
            this.outgoingItems.length > 0 &&
            this.changeTotal > 10
          )
        },

        /**
         * 
         */
        changeTotal() {
          return this.outgoingTotal - this.incomingTotal
        },

        /**
         * 
         */
        incomingItems() {
          return this.invoice ? this.slSaleInvoice.details : this.slSaleTicket.details
        },

        /**
         * 
         */
        incomingTotal() {
          return Math.ceil(this.incomingTotalFloat)
        },

        /**
         * 
         */
        incomingTotalFull() {
          return Math.ceil(this.incomingTotalFloatFull)
        },

        /**
         * 
         */
        incomingTotalFloat() {
          return this.incomingItems.reduce((total, item) => {
            // item
            let iQty = parseFloat(item.quantity)
            let iQtc = parseFloat(item.quantity_change)
            let iPrc = parseFloat(item.price)
            // discount
            let iPtg = parseFloat(item.discount_percentage)
            let iDsc = this.invoice ? parseFloat(item.discount_or_charge_value_with_iva) : parseFloat(item.discount_or_charge_value)
            // total
            let iTtl = iQtc * iPrc * iPtg
            // required discount by value
            let iRpt = iPtg < 1
            let iRdc = iQtc < iQty
            let iSum = iRpt || iRdc ? Math.max(0, iTtl) : iTtl - iDsc
            // total result
            let rTtl = total + iSum
            // console.log({ rTtl })
            return rTtl
            // return total + (parseFloat(item.quantity_change) * parseFloat(item.price) * parseFloat(item.discount_percentage))
          }, 0)
        },

        /**
         * 
         */
        incomingTotalFloatFull() {
          return this.incomingItems.reduce((total, item) => { 
            // let iQty = parseFloat(item.quantity)
            let iQty = parseFloat(item.quantity)
            let iQtc = parseFloat(item.quantity_change)
            let iPrc = parseFloat(item.price)
            let iPtg = parseFloat(item.discount_percentage)
            let iDsc = this.invoice ? parseFloat(item.discount_or_charge_value_with_iva) : parseFloat(item.discount_or_charge_value)
            
            let iRdc = iQtc < iQty
            let iRpt = iPtg < 1
            let iTtl = iRpt || iRdc ? (iQtc * iPrc * iPtg) : (iQtc * iPrc * iPtg) - iDsc
            let iSum = Math.max(0, iTtl)
            let rTtl = total + iSum
            return rTtl
            // return total + (parseFloat(item.quantity) * parseFloat(item.price) * parseFloat(item.discount_percentage))
          }, 0)
        },

        /**
         * 
         */
        outgoingItems() {
          return this.items
        },

        /**
         * 
         */
        outgoingTotal() {
          return parseFloat(this.total)
        },

        /**
         * 
         */
        posSaleTypeComputed() {
          return this.invoice ? 2 : 1
        },

        /**
         * 
         */
        showSnackbar() {
            return !!this.errorMessage
        },
        originalTotal() {
            if (!this.incomingList || !this.incomingList.length) return null
            return this.incomingList.reduce(
                (total, item) => total + item.quantity * item.price,
                0
            )
        },
        submitdata: function () {
            const incoming = () => {
                return this.incomingList
                    .map((item) => {
                        return {
                            product_id: item.id,
                            quantity: item.incomingQuantity,
                        }
                    })
                    .filter((item) => item.quantity > 0)
            }
            const saleDetail = () => {
                return this.items.map((item) => {
                    return {
                        product_id: item.id,
                        quantity: item.quantity,
                        price: parseInt(item.sale_price),
                        discount: 0,
                        discount_unit_price: 0,
                        wh_warehouse_id: item.active_warehouse,
                    }
                })
            }
            let request = {
                comment: '-',
                dte_number: this.docNumber,
                is_ticket: !this.invoice,
                seller_user_id: this.salespersonID,
                supervisor_user_id: this.supervisorID,
                seller_user_code: this.salespersonCode,
                supervisor_user_code: this.supervisorCode,
                in: incoming(),
                customer_id: null,
                customer: null,
                sucursal_id: 1, // variable no usada en back tranquilo
                pos_sale_type: this.posSaleTypeComputed,
                global_discount: 0,
                total: this.total - this.incomingTotal,
                global_discount_amount: 0,
                sale_detail: saleDetail(),
            }
            return request
        },
        enableTransaction: function () {
            if (
                this.total < this.incomingTotal ||
                this.items.length == 0 ||
                this.incomingList.length == 0 ||
                this.incomingTotal == 0
            )
                return false
            return true
        },

      /**
       * 
       */
      hasSaleTicket() {
        return this.slSaleTicket
      },
    },
    methods: {
        ...mapActions('CartModule', {
            clearCart: 'resetState',
        }),
        ...mapActions('CustomerModule', {
            clearCustomer: 'resetState',
        }),
        ...mapActions('TransactionModule', {
            clearTransaction: 'resetState',
        }),
        ...mapActions('PromoModule', {
            clearPromos: 'resetState',
        }),
        ...mapActions('SnackbarModal', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         * 
         */
        async change() {
          this.dialogs.change = true
          await SlServiceOrderService.change(this.getChangeData()).then(this.print).catch(this.handleChangeError)
          this.dialogs.change = false
        },

        /**
         * 
         */
        clearAllData: function (noReload = false) {
            this.clearCart()
            this.clearCustomer()
            if (!noReload) {
                this.clearTransaction()
                window.location.reload()
            }
        },

        /**
         * 
         */
        filterByExistsInItems(i) {
          return this.items.every(j => {
            return j.id !== i.wh_product_id
          })
        },

        /**
         * 
         */
        filterByQuantity(item) {
          return item.quantity > 0 
        },

        /**
         * 
         */
        filterByTotalQuantity(item) {
          return parseFloat(item.quantity) > parseFloat(item.quantity_change)
        },

        /**
         * 
         */
        getAuthorization(code) {         
          return GAuthorizationService.getByCode(code).then(res => {
            this.setAuthorization(res.shift(), code)
          })
        },

        /**
         * 
         */
        getBarAuthorization(code) {         
          return GBarAuthorizationService.getByCode(code).then(res => {
            this.setBarAuthorization(res.shift(), code)
          })
        },

        /**
         * 
         */
        getChangeData() {
          return {
            comment               : '',
            customerId            : this.customerId, // only with invoice
            defaultBranchOfficeId : this.customerBranchOfficesId,
            number                : this.number, // input number
            globalDiscount        : 0, // no usado
            globalDiscountAmount  : 0, // no usado
            gCoreBusinessSIIId    : this.customerCoreBusinessId,
            in                    : this.getIncomingItems(), // incoming items
            isTicket              : !this.invoice, // input switch
            posSaleType           : this.posSaleTypeComputed, // input switch computed
            saleDetail            : this.getOutgoingItems(), // outgoing items
            sellerUserId          : this.salesPersonId, // auth code data
            sellerUserCode        : this.salesPersonCode, // auth code data
            sucursalId            : this.sucursalId, // variable no usada en back tranquilo
            supervisorUserId      : this.supervisorId, // auth bar code data
            supervisorUserCode    : this.supervisorCode, // auth bar code data
            total                 : this.changeTotal // computed total,
          }
        },

        /**
         * 
         */
        getChangeOptions() {
          return {
            companyAddress            : this.companyData.address,
            companyBusinessName       : this.companyData.business_name,
            companyCommercialBusiness : this.companyData.commercial_business,
            companyRut                : this.companyData.rut,
            customer                  : this.customer,
            incomingDetail            : this.getIncomingPrintItems(), // incoming items
            incomingTotal             : this.incomingTotalFull,
            invoice                   : this.invoice, // input switch
            items                     : this.getPrintItems(),
            seller                    : this.salesPersonName,
            total                     : this.getPrintItems().reduce((e,i) => e + i.subtotal, 0), // computed total,
          }
        },

        /**
         *
         */
        getDocument() {
          return this.invoice ? this.getSaleInvoice() : this.getSaleTicket()
        },

        /**
         * 
         */
        getIncomingItems() {
          return this.incomingItems.map(this.mapIncomingItem).filter(this.filterByQuantity)
        },

        /**
         * 
         */
        getIncomingPrintItems() {
          return this.incomingItems.map(this.mapPrintItem).filter(i => {
            return i.incomingQuantity > 0
          })
        },

        /**
         * 
         */
        getOutgoingItems() {
          return this.outgoingItems.map(this.mapOutgoingItem)
        },

        /**
         * 
         */
        getPrintItems() {
          // return this.items
          return this
            // .incomingItems
            .items
            // .filter(this.filterByExistsInItems)
            // .filter(this.filterByTotalQuantity)
            // .map(this.mapPrintOutgoingItem)
            // .concat(this.items)
            .map(this.mapPrintOutgoingProduct)
        },

        /**
         *
         */
        async getSaleInvoice() {
          this.slSaleInvoice = await SlSaleInvoiceService.getByNumber(this.number)
            .then(this.mapFirst)
            .then(this.mapSaleInvoice)
          this.customer                 = this.slSaleInvoice.sl_customer
          this.customerId               = this.slSaleInvoice.sl_customer_id
          this.customerBranchOfficesId  = this.slSaleInvoice.sl_customer_branch_offices_id
          this.customerCoreBusinessId   = this.slSaleInvoice.first_pos_sale ? this.slSaleInvoice.first_pos_sale.g_core_business_sii_id : null
          this.sucursalId               = this.slSaleInvoice.first_pos_sale.g_branch_office_id
        },

        /**
         *
         */
        async getSaleTicket() {
          this.slSaleTicket = await SlSaleTicketService.getByNumber(this.number)
            .then(this.mapFirst)
            .then(this.mapSaleTicket)
          this.customerId               = this.slSaleTicket.sl_customer_id
          this.customerBranchOfficesId  = this.slSaleTicket.first_pos_sale.sl_customer_branch_offices_id
          this.sucursalId               = this.slSaleTicket.first_pos_sale.g_branch_office_id
        },

        /**
         * 
         */
        handleChangeError(error) {
          console.log({ error })
          this.error = error.response.data.error
          this.dialogs.error = true
        },

        /**
         * 
         */
        handleCleanClick() {
          this.number = ''
          this.slSaleTicket = {
            details: []
          }
          this.slSaleInvoice = {
            details: []
          }
          this.clearCart()
          this.clearCustomer()
        },

        /**
         * 
         */
        handleConfirmClick() {
          if (this.outgoingTotal - this.incomingTotal < 10) {
            this.error = 'El monto minimo para realizar un cambio es de $10.'
            this.dialogs.error = true
            return
          }
          this.dialogs.confirm = true
        },

        /**
         *
         */
        handleDocumentError(error) {
          this.error = 'No se pudo obtener el documento (El documento no existe).'
          this.dialogs.error = true
        },

        /**
         *
         */
        async handleNumberEnter() {
          this.busy.number = true
          await this.getDocument().catch(this.handleDocumentError)
          this.busy.number = false
        },

        /**
         * 
         */
        async handleSalesPersonSubmit(code) {
          let cStr = String(code)
          let cRdy = this.prependZeros(cStr, 3)
          await this.getAuthorization(cRdy)
        },

        /**
         * 
         */
        async handleSupervisorSubmit(code) {
          let cStr = String(code)
          await this.getBarAuthorization(cStr)
        },

        /**
         * 
         */
        mapDetailSaleInvoice: (item) => {
          let iNetPrice = parseFloat(item.net_price)
          let iPrice    = Math.round(iNetPrice * 1.19)
          // discounts
          // console.log(item.price)
          // console.log(item.discount_or_charge_value)
          // console.log(item.remaining_amount)
          item.discount_or_charge_value_with_iva  = Math.round(item.discount_or_charge_value * 1.19)
          item.discount_percentage_factor         = parseFloat(item.discount_or_charge_percentage) / 100
          item.discount_percentage                = 1 - item.discount_percentage_factor
          item.discount_percentage_multiple       = item.discount_percentage_factor / item.discount_percentage
          // totals
          item.price            = iPrice
          // item.price            = Math.round(item.price_with_discount * 1.19 * (1 + item.discount_percentage_multiple))
          item.quantity         = parseFloat(item.quantity)
          item.quantity_change  = 0
          item.remaining_amount = (item.price * item.quantity) - item.discount_or_charge_value_with_iva
          // item.remaining_amount = Math.ceil(item.remaining_amount * 1.19)
          //
          // console.log({ item })
          return item
        },

        /**
         * 
         */
        mapDetailSaleTicket: (item) => {
          item.discount_or_charge_value_with_iva = item.discount_or_charge_value
          item.discount_percentage_factor = parseFloat(item.discount_or_charge_percentage) / 100
          item.discount_percentage        = 1 - item.discount_percentage_factor
          item.quantity_change            = 0
          return item
        },

        /**
         * 
         */
        mapFirst: (res) => {
          if (!res[0].id) throw 'El documento no existe.'
          return res[0] || {}
        },

        /**
         * 
         */
        mapIncomingItem(item) {
          return {
            product_id: item.wh_product_id,
            quantity  : parseFloat(item.quantity_change),
          }
        },

        /**
         * 
         */
        mapOutgoingItem(item) {
          let dPtg = parseFloat(item.lineDiscount.percentage_discount || 0)
          let dUpr = parseFloat(item.lineDiscount.unit_price_discount || 0)
          // let dPrc = parseInt(item.sale_price) * ( dPtg / 100 )
          // console.log({ itemOutgoing: item })
          return {
            product_id          : item.id,
            quantity            : parseFloat(item.quantity),
            price               : parseInt(item.discounted_price || item.sale_price),
            discount            : dPtg,
            discount_unit_price : dUpr,
            wh_warehouse_id     : item.active_warehouse,
          }
        },

        /**
         * 
         */
        mapPrintItem(item) {
          console.log({ printItem: item })
          //
          let dPtg = parseFloat(item.discount_or_charge_percentage)
          let iInv = this.invoice
          let iPrc = item.price
          let iPrd = item.price_with_discount
          let iQty = parseFloat(item.quantity)
          let iQtc = parseFloat(item.quantity_change)
          let iQtd = iQty - iQtc
          let iPri = dPtg ? iPrd : iQtd ? iPrc : iPrd
          // let rPrc = iPri
          let rPrc = iInv && iPri !== iPrc ? Math.round(iPri * 1.19) : iPri
          //
          return {
            ...item.wh_product,
            sale_price      : rPrc,
            price           : rPrc,
            // price           : this.invoice ? Math.round(item.price_with_discount * 1.19) : item.price_with_discount,
            // price           : item.price_with_discount,
            quantity        : parseFloat(item.quantity),
            // subtotal        : (parseFloat(item.quantity) - parseFloat(item.quantity_change)) * item.price_with_discount,
            subtotal        : parseFloat(item.quantity_change) * rPrc,
            incomingQuantity: parseFloat(item.quantity_change),
          }
        },

        /**
         * 
         */
        mapPrintOutgoingItem(item) {
          let iDpt = parseFloat(item.discount_percentage)
          let iDsc = this.invoice ? parseFloat(item.discount_or_charge_value_with_iva) : parseFloat(item.discount_or_charge_value)
          let iPro = parseFloat(item.price)
          let iPrd = this.invoice ? Math.ceil(parseFloat(item.price_with_discount) * 1.19) : parseFloat(item.price_with_discount)
          let iPrc = iDpt < 1 ? iPrd : iPro
          let iQty = parseFloat(item.quantity)
          let iQtc = parseFloat(item.quantity_change)
          let iQtd = iQty - iQtc
          let iSbt = iDpt < 1 ? (iQtd * iPrc) : (iQtd * iPrc) - iDsc
          // console.log({ printOutgoingItem: item })
          return {
            ...item.wh_product,
            sale_price      : iPrc,
            price           : iPrc,
            quantity        : iQtd,
            subtotal        : iSbt,
            incomingQuantity: iQtc,
          }
        },

        /**
         * 
         */
        mapPrintOutgoingProduct(item) {
          // 
          let dPtg = item.lineDiscount ? parseFloat(item.lineDiscount.percentage_discount || 0) : 0
          let sPrc = item.lineDiscount ? item.sale_price * (1 - (dPtg / 100)) : item.sale_price
          // 
          return {
            ...item,
            sale_price: sPrc,
          }
        },
        
        /**
         * 
         */
        mapSaleInvoice(item) {
          item.details = item.details.map(this.mapDetailSaleInvoice)
          return item
        },
        
        /**
         * 
         */
        mapSaleTicket(item) {
          item.details = item.details.map(this.mapDetailSaleTicket)
          return item
        },

        /**
         * 
         */
        prependZeros(code, length) {
          let count = length - code.length
          let prepend = ''
          if (count > 0) {
            for (let i = 0; i < count; i++) {
              prepend += '0'
            }
          }
          return prepend + '' + code
        },

        /**
         * 
         */
        async print(res) {

          // required data
          let tCode = res.data.sale_id_formatted
          let tDate = res.data.created_at.date
          let tMode = res.data.service_order_id
          let tOpts = this.getChangeOptions()

          // imprimir dos copias
          // await SlServiceOrderService.printChangeTicket(tCode, tDate, tMode, tOpts)
          await Promise
            .all([ 
              SlServiceOrderService.printChangeTicket(tCode, tDate, tMode, tOpts),
              SlServiceOrderService.printChangeTicket(tCode, tDate, tMode, tOpts),
            ])
            // .then(() => {
            //   return SlServiceOrderService.printChangeTicket(tCode, tDate, tMode, tOpts)
            // })
            .then(() => {
              this.success = 'Cambio realizado exitosamente.'
              this.dialogs.success = true
            })
            .then(this.handleCleanClick)
            .catch((error) => {
              this.error = 'Error al imprimir documento'
              this.dialogs.error = true
            })

          // // primera impresion
          // await SlServiceOrderService.printChangeTicket(tCode, tDate, tMode, tOpts)
          // .catch((error) => {
          //   // console.log({ error })
          //   this.error = 'Error al imprimir documento'
          //   this.dialogs.error = true
          // })
          // .then(() => {
          //   this.handleCleanClick()
          //   this.success = 'Cambio realizado exitosamente.'
          //   this.dialogs.success = true
          // })
        },

        /**
         * 
         */
        setAuthorization(auth, code) {
          if (auth.is_authorized) {
            this.salesPersonCode = code
            this.salesPersonID = auth.user.id
            this.salesPersonName = auth.user.names + ' ' + auth.user.last_name1
            this.salesPersonStatus = true
            this.dialogs.confirm = false
            this.dialogs.supervisor = true
          }
        },

        /**
         * 
         */
        setBarAuthorization(auth, code) {
          if (auth.is_authorized) {
            this.supervisorCode = code
            this.supervisorId = auth.user.id
            this.supervisorStatus = true
            this.dialogs.supervisor = false
            this.change()
          }
        },

        searchDocument: async function (docNumber) {
            if (!docNumber) return
            this.loadingDocument = true
            //
            const response = await axios.get(
                this.invoice
                    ? this.invoiceRoute(docNumber)
                    : this.ticketRoute(docNumber)
            )
            console.log({ response })
            //
            this.loadingDocument = false
            //
            if (!response.data.id) {
                this.errorMessage =
                    'Documento No encontrado,<br>' +
                    'verifique tipo documento seleccionado'
                setTimeout(() => (this.errorMessage = ''), 10000)
                return
            }
            if (response.data.was_replaced) {
                this.errorMessage = 'Este documento ya fue cambiado o anulado'
                setTimeout(() => (this.errorMessage = ''), 10000)
                return
            }

            this.changeMode = true
            let list = this.responseToProductsList(response)
            let err = list.find((i) => i._error)
            if (err) {
                this.errorMessage = err._error
                this.loadingDocument = false
                return
            }
            this.incomingList = list
            this.incomingList = this.incomingList.map((i) => {
                let newObj = { ...i }
                if (i.price === undefined) {
                    newObj.price = Math.round(i.net_price * 1.19)
                }
                return newObj
            })
            this.setCustomerID(response.data.sl_customer_id)
            this.setCustomerBranchOffice(
                response.data.sl_customer_branch_offices_id
            )
            this.setCustomerCoreBusinessId(
                response.data && response.data.first_pos_sale
                    ? response.data.first_pos_sale.g_core_business_sii_id
                    : null
            )
            this.$nextTick(() => this.$refs.docsearch.blur())
        },
        ticketRoute: function (docNumber) {
            return (
                route +
                'sl_sale_ticket/number/' +
                docNumber +
                '?include=sl_detail_sale_tickets.wh_product'
            )
        },
        invoiceRoute: function (docNumber) {
            return (
                route +
                'sl_sale_invoice/number/' +
                docNumber +
                '?include=sl_detail_sale_invoices.wh_product,first_pos_sale'
            )
        },
        responseToProductsList(response) {
            const dte =
                'sl_detail_sale_' + (this.invoice ? 'invoices' : 'tickets')
            // if (
            //     parseInt(response.data.global_discount_amount) ||
            //     parseInt(response.data.global_discount_percentage)
            // ) {
            //     this.clearAllData(true)
            //     let errorMessage =
            //         'La venta tiene un descuento global asociado,<br>' +
            //         'no pueden hacerse cambios a documentos que contengan descuentos.<br>' +
            //         ' Debe generar una nota de crédito y una nueva venta'
            //     this.errorMessage = errorMessage
            //     setTimeout(() => (this.errorMessage = ''), 10000)
            //     return { _error: errorMessage }
            // }
            return response.data[dte].map((line, idx) => {
                // if (
                //     parseInt(line.discount_or_charge_percentage) ||
                //     parseInt(line.discount_or_charge_amount)
                // ) {
                //     this.clearAllData(true)
                //     this.errorMessage =
                //         `Descuento encontrado en línea ${idx + 1}<br>` +
                //         `Producto ${line.wh_product.name}<br>` +
                //         'No puede realizar cambio para este documento,' +
                //         ' debe generar una nota de crédito y una nueva venta'
                //     setTimeout(() => (this.errorMessage = ''), 10000)
                //     return
                // }
                const product = line.wh_product
                for (let prop in line) {
                    if (line.hasOwnProperty(prop)) {
                        if (
                            [
                                'discount_or_charge_percentage',
                                'discount_or_charge_value',
                                'price',
                                'net_price',
                                'quantity',
                                'subtotal',
                            ].includes(prop)
                        )
                            product[prop] = line[prop]
                    }
                }
                product.incomingQuantity = 0
                return product
            })
        },
        printSaleTicket: async function (
            barcode = '123456789123',
            dateTime = null,
            quotationMode = false
        ) {
            //let win = window.open('boleta2.html', '_blank')
            let obj = {}
            obj.slID = quotationMode
            obj.quotation = false
            obj.seller = this.salesPersonName || 'Vendedor de Prueba'
            obj.quotationExpiration = null
            obj.isQuotation = false

            obj.closeTimeout = process.env.VUE_APP_PRINTER_TIMEOUT
            obj.editMode = false

            //console.log(this.items,)

            obj.barcode = barcode
            obj.items = this.items.concat(
                this.incomingList
                    .filter((inc) => {
                        return this.items.every((it) => it.id !== inc.id)
                    })
                    .map((e) => {
                        e.sale_price = Number(e.price)
                        return e
                    })
            )
            obj.total = this.total
            obj.incomingDetail = this.incomingList.filter((i) => i.quantity > 0)
            obj.incomingTotal = this.incomingTotal
            obj.global_discount = { amount_discount: this.incomingTotal }
            obj.globalDiscount = { amount_discount: this.incomingTotal }
            obj.dateTime = { date: null, time: null }
            if (dateTime) obj.dateTime = splitDateTimeString(dateTime)
            obj.subtitle = `TICKET DE CAMBIO N°${barcode.substr(2)}`
            obj.title = this.companyData.business_name
            obj.RUT = this.companyData.rut
            obj.activities = this.companyData.commercial_business
            obj.address = this.companyData.address
            obj.typeCode = 6
            obj.saleType = this.invoice ? 'FACTURA' : 'BOLETA'

            obj.mockData = {
                slID: quotationMode,
                quotation: false,
                seller: this.salesPersonName,
                closeTimeout: process.env.VUE_APP_PRINTER_TIMEOUT,
                barcode,
                items: this.items,
                total: this.total,
                incomingDetail: this.incomingList,
                incomingTotal: this.incomingTotal,
                global_discount: { amount_discount: this.incomingTotal },
                dateTime: splitDateTimeString(dateTime),
                subtitle: 'TICKET DE CAMBIO',
            }
            if (this.htmlPrint) {
                let win = window.open('boleta2.html', '_blank')
                Object.assign(win.window, obj)
                return true
            } else {
                const data = cloneDeep(obj)
                data.items = this.items
                data.incomingDetail = this.incomingList
                    .map((i) => {
                        i.quantity = i.incomingQuantity
                        i.subtotal = i.incomingQuantity * i.sale_price
                        return i
                    })
                    .filter((i) => i.quantity)

                // Uncomment to see printer request payload
                // console.log(printerApi.formatPayload(data))
                // return

                let timeout = () =>
                    new Promise((resolve, reject) => {
                        setTimeout(
                            () => reject('Tiempo de espera agotado'),
                            process.env.VUE_APP_PRINTER_SERVICE_TIMEOUT
                                ? parseInt(
                                      process.env
                                          .VUE_APP_PRINTER_SERVICE_TIMEOUT
                                  )
                                : 8000
                        )
                    })
                let promise = Promise.race([printerApi.print(data), timeout()])
                let comp = null
                try {
                    let comp = await promise
                    return comp
                } catch (e) {
                    console.log('ERROR', e)
                    try {
                        let win = window.open('boleta2.html', '_blank')
                        Object.assign(win.window, obj)
                        return true
                    } catch (e) {
                        return false
                    }
                }
            }
        },
        handleCounter() {
            this.incomingList = JSON.parse(JSON.stringify(this.incomingList))
        },
        submitChange(authCode) {
            let response = null
            let data = this.submitdata
            this.submitdata.customer_id = this.customer_id
            this.submitdata.default_branch_office_id = this.customer_branch_office_id
            this.submitdata.g_core_business_sii_id = this.customer_core_business_id
            data.supervisor_user_code = authCode

            // Uncomment to see printer request payload
            // this.printSaleTicket('SX0000PALTA', '2020-02-25 16:26:15', 123)
            // return

            axios
                .post(route + 'sl_service_order/change', this.submitdata)
                .then((res) => {
                    response = res
                    if (response && response.data) {
                        this.printSaleTicket(
                            response.data.sale_id_formatted,
                            response.data.created_at.date,
                            response.data.service_order_id
                        )
                            .then(() =>
                                //this.clearAllData()
                                this.printSaleTicket(
                                    response.data.sale_id_formatted,
                                    response.data.created_at.date,
                                    response.data.service_order_id
                                ).then(() => this.clearAllData())
                            )
                            .catch(console.log)
                    }
                    //this.clearAllData()
                })
                // .catch(err => console.log(err))
                .catch(this.onErrorChange)
        },
        submitAuth: async function (code) {
            try {
                let route =
                    process.env.VUE_APP_API_ROUTE +
                    '/bar_authorization?auth_code=' +
                    code +
                    '&permission=authorize%20change%20product'
                axios.get(route).then((response) => {
                    if (response.data.is_authorized) {
                        this.supervisorCode = code
                        this.supervisorID = response.data.user.id
                        this.show = false
                        this.authStatus = true
                        this.submitChange(code)
                    } else {
                        this.authStatus = false
                    }
                })
            } catch (error) {
                return null
            }
        },
        submitSalespersonCode: function (code) {
            // FIXME: Remove heading 0s when in production
            const prependZeros = function (string, length) {
                let count = length - string.length
                let prepend = ''
                if (count > 0) {
                    for (let i = 0; i < count; i++) {
                        prepend += '0'
                    }
                }
                return prepend + '' + string
            }
            code = prependZeros(code, 3)
            let route =
                process.env.VUE_APP_API_ROUTE +
                '/authorization?auth_code=' +
                code +
                '&permission=access_to%20point_sale'
            axios
                .get(route)
                .then((response) => {
                    let r = { ...response }
                    if (response.data.is_authorized) {
                        this.salespersonCode = code
                        this.salespersonID = response.data.user.id
                        this.salesPersonName =
                            response.data.user.names +
                            ' ' +
                            response.data.user.last_name1
                        // this.checkAuth()
                        this.showSalespersonModal = false
                        this.salespersonStatus = true
                        this.show = true
                    } else {
                        this.salespersonStatus = false
                    }
                })
                .catch((error) => {
                    this.salespersonStatus = false
                })
        },
        handleScannerBlur() {},
        handleDocNumBlur(e) {
            e.stopImmediatePropagation()
            setTimeout(() => {
                if (document.activeElement.tagName === 'BODY') {
                    this.$nextTick(() => {
                        document.getElementById('barcode-scanner-input').focus()
                    })
                }
            }, 200)
        },
        /*
         */
        setCustomerID(id) {
            this.customer_id = id
        },
        setCustomerCoreBusinessId(id) {
            this.customer_core_business_id = id
        },
        /*
         */
        setCustomerBranchOffice(id) {
            this.customer_branch_office_id = id
        },
        handleSubmit() {
            if (this.total - this.incomingTotal < 10) {
                this.errorMessage =
                    'El monto para cambios debe ser de al menos $10'
                setTimeout(() => (this.errorMessage = null), 7000)
                return
            }
            this.showSalespersonModal = true
        },
        /**
         *
         */
        onErrorChange(error) {
            const body = error.response.data.error
            const title = error.response.data.message
            // console.log({ error })
            this.$store.dispatch('SnackbarModal/initSnackbar', {
                message: {
                    title,
                    body,
                },
                typeMessage: 'error',
                timeout: 0,
            })
        },
    },
    props: {

      /**
       * 
       */
      headers: {
        type: Array,
        default: () => [
          {
            text: 'Cantidad',
            class: 'grey darken-4 white--text text-uppercase',
            value: 'quantity',
          },
          {
            text: 'Nombre',
            class: 'grey darken-4 white--text text-uppercase',
            value: 'id',
          },
          {
            align: 'center',
            text: 'Precio',
            class: 'grey darken-4 white--text text-uppercase',
            value: 'price',
          },
          {
            align: 'center',
            text: 'Descuento',
            class: 'grey darken-4 white--text text-uppercase',
            value: 'discount_or_charge_value',
          },
          {
            align: 'center',
            text: 'Subtotal',
            class: 'grey darken-4 white--text text-uppercase',
            value: 'remaining_amount',
          },
        ]
      },
    },
    watch: {
        /**
         * @description
         */
        activeTransaction: function (newVal, oldVal) {
            if (newVal != 6) this.$router.push('/')
        },
    },
    components: {
        CounterControl,
        SalesCart,
        AuthModal,
        'salesperson-modal': SalespersonModal,
    },
    mixins: [TextFormatting, CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function () {
        if (this.activeTransaction.id != 6) this.$router.push('/')
    },
    // beforeMount: function(){...},
    mounted: function () {
        this.$nextTick(() => this.$refs.docsearch.focus())
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style>
  .fullheight {
    height: 100%;
    overflow: auto;
  }
  .column {
    flex-direction: column;
  }
  .row {
    flex-direction: row;
  }
  #change .theme--light.v-datatable thead th.column.sortable.active .v-icon {
  color: white;
  }
  td .green .ButtonIcon {
    margin: 0 !important;
  }
  td .red .ButtonIcon {
    margin: -8px 0 0 !important;
  }
</style>
